/**
 * Merge-field renderer for installer templates.
 *
 * A template's `body_text` may contain any of these tokens (both `{{token}}`
 * and `{token}` forms are recognised — installers copy-paste from all sorts
 * of places so we forgive both):
 *
 *   customer_name   · project.customer_name
 *   customer_address· project.customer_address
 *   project_ref     · project.reference
 *   install_date    · project.install_date (formatted en-GB)
 *   installer_name  · user.name
 *   company_name    · user.company_name
 *   today           · today's date (formatted en-GB)
 *
 * Unknown tokens are left as-is so nothing is silently lost.
 */

const gbDate = (v) => {
  if (!v) return '';
  try {
    return new Date(v).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  } catch { return String(v); }
};

export const MERGE_FIELDS = [
  { token: 'customer_name',    label: 'Customer name' },
  { token: 'customer_address', label: 'Customer address' },
  { token: 'project_ref',      label: 'Project reference' },
  { token: 'install_date',     label: 'Install date' },
  { token: 'installer_name',   label: 'Your name' },
  { token: 'company_name',     label: 'Your company' },
  { token: 'today',            label: "Today's date" },
];

export function buildMergeContext({ project, user }) {
  const p = project || {};
  const u = user || {};
  return {
    customer_name:    p.customer_name || '',
    customer_address: p.customer_address || '',
    project_ref:      p.reference || '',
    install_date:     gbDate(p.install_date),
    installer_name:   u.name || '',
    company_name:     u.company_name || '',
    today:            gbDate(new Date()),
  };
}

export function renderMergeFields(template, ctx) {
  if (!template) return '';
  // Match `{{token}}` and `{token}` — tolerating whitespace inside braces.
  return template
    .replace(/\{\{\s*([a-z_]+)\s*\}\}/gi, (m, k) => (k in ctx ? ctx[k] : m))
    .replace(/\{\s*([a-z_]+)\s*\}/gi,     (m, k) => (k in ctx ? ctx[k] : m));
}
